<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="字段名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=50
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="value"
                    label="值"
                    prop="value"
                    :help="formErr.value"
                    :validateStatus='!formErr.value||formErr.value==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.value"
                        @change="(e) => { formErr.value=''}"
                        @blur="(e) => {  form.value = e.target.value.trim() }"
                />
            </a-form-model-item>

        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }" >
                确定
            </a-button>
            <a-button  @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "pageForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig,
                form: {
                    value:"",
                    name:""
                },
                formErr: {
                    value:"",
                    name:""
                },
                rules: {
                    name: [ {required: true, message: "请输入字段名称 ", trigger: "blur"},,{ whitespace: true, message: "请输入字段名称 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  }, ],
                    value: [{required: true, message: "请输入值 ", trigger: "blur"}, {  whitespace: true, message: "请输入值 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.value)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.pageContent.EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={ value:"", name:"" }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.pageContent.SUBMIT_ADD : url = API.pageContent.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
